import PaintQuotationsWorkspace from '../../placeholders/PaintQuotationsWorkspace';

export default PaintQuotationsWorkspace;
